(() => {
  if (customElements.get('aura-announcement-bar')) return;
  customElements.define('aura-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.messages = [...this.querySelectorAll('.aura-announcements__message')];
      this.pause = this.querySelector('.aura-announcements__pause');
      this.mobile = matchMedia('(max-width:1199px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.index = 0;
      this.paused = this.reduced.matches;
      this.onPause = () => { this.paused = !this.paused; this.update(); };
      this.onMode = () => this.update();
      this.onVisibility = () => this.update();
      this.pause?.addEventListener('click', this.onPause);
      this.mobile.addEventListener('change', this.onMode);
      this.reduced.addEventListener('change', this.onMode);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.update();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.pause?.removeEventListener('click', this.onPause);
      this.mobile.removeEventListener('change', this.onMode);
      this.reduced.removeEventListener('change', this.onMode);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    update() {
      clearInterval(this.timer);
      this.pause?.setAttribute('aria-pressed', String(this.paused));
      this.pause?.setAttribute('aria-label', this.paused ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel);
      this.show();
      if (this.mobile.matches && !this.paused && !this.reduced.matches && !document.hidden) {
        this.timer = setInterval(() => { this.index = (this.index + 1) % this.messages.length; this.show(); }, 7000);
      }
    }
    show() {
      this.messages.forEach((message, index) => {
        const visible = !this.mobile.matches || index === this.index;
        message.classList.toggle('is-active', visible);
        message.setAttribute('aria-hidden', String(!visible));
      });
    }
  });
})();
